import styled, { css } from "styled-components/macro"
import { Icon, IconButton } from "@humanpredictiveintelligence/myqvt-library"

import { Choice, LazyQuestionChoices  } from "../../../LazyQuestionChoices"

export const Container = styled.div`
  ${({ theme }) => css`
    min-height: fit-content;
    display: flex;
    top: 0;
    padding: 0.5rem;
    width: 100%;
    border-radius: 1rem;
    bottom: 0;
    align-items: flex-start;
    justify-content: space-between;
    gap: 10px;
    border: 1px solid ${theme.colors.primary};
  `}
`

export const Question = {
  Choices: styled(LazyQuestionChoices)`
    margin-bottom: 0;

    ${Choice}:first-child {
      margin-top: 0;
    }

    ${Choice}:last-child {
      margin-bottom: 0;
    }
  `,
  DragHandle: styled(Icon)`
    cursor: grab;
    
    &:active {
      cursor: grabbing;
    }
  `,
  Label: styled.div`
    ${({ theme: { colors, typography, sizes } }) => css`
      background-color: ${colors.primaryLight};
      border-radius: ${sizes.borderRadiusRounded};
      padding: 10px 8px;
      color: ${colors.blackMedium};
      font-size: ${typography.fontSizeLabelMedium};
      text-transform: uppercase;
      font-weight: ${typography.fontWeightMedium};
    `}
  `,
  LabelAndHandel: styled.div`
    display: flex;
    gap: 8px;
  `,
  Name: styled.div`
    font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
  `,
  NameAndChoices: styled.div`
    flex: 1;
    width: 100%;
  `,
  RemoveAction: styled(IconButton)`
    align-self: flex-start;
  `,
}
